import TaskViewAsExecutor from './TaskViewAsExecutor';
import RightSidebarViewTaskAsExec from './RightSidebarViewTaskAsExec';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';

export default ColumnsContent(TaskViewAsExecutor, RightSidebarViewTaskAsExec);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/TaskViewAsExecutor/Content.js